var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{on:{"click":_vm.handleClick}},[_c('GoogleLogin',{staticClass:"google-login",attrs:{"params":_vm.params,"on-success":_vm.handleSuccess,"on-failure":_vm.handleFailure}},[_c('img',{staticClass:"w-20 inline",attrs:{"src":require("@/assets/svg/google-icon.svg"),"alt":"Google logo"}}),_vm._v(" Sign in with Google ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }